import buildMRHostedFileURL from 'app/components/analytics-builder/buildMRHostedFileUrl';

export default function buildEndpointUrls({ analyticsFile, pipeline, showMRHostedUrls }) {
  const host = analyticsFile?.settings?.host;
  const cdnURL = analyticsFile?.settings?.cdnURL;

  if (!host && !cdnURL) {
    return [];
  }

  if (showMRHostedUrls) {
    const urls = [];
    if (cdnURL) {
      urls.push({
        label: 'Distribution URL',
        url: cdnURL,
        description: 'The URL used by client devices to fetch this file, typically served through a CDN.',
      });
    }
    if (host) {
      urls.push({
        label: 'Cluster Endpoint',
        url: buildMRHostedFileURL(host, pipeline?.writekey),
        description:
          'The URL where the latest version of your file can be retrieved. Use this endpoint to automate file fetching via a CDN, CI/CD pipeline, or other tooling.',
      });
    }
    return urls;
  }

  const urls = [];
  if (cdnURL) {
    urls.push({
      label: 'Hosting URL',
      url: cdnURL,
      description: 'The URL where you host your analytics file for client devices to fetch.',
    });
  }
  if (host) {
    urls.push({
      label: 'Ingestion URL',
      url: host,
      description: 'The event ingestion endpoint for your MetaRouter cluster.',
    });
  }
  return urls;
}
